<template>
    <div id="app">
        <router-view v-if="isRouterAlive" />
    </div>
</template>

<script>
import { cart, getUser } from "@/api/app";
import store from '@/store/index.js'
import { v4 as uuidv4 } from 'uuid'
//import { connectWebSocket, websocket, closeWebsocket } from '@/utils/websocket.js'
export default {
    name: "App",
    provide() {
        return {
            reload: this.reload,
        };
    },
    data() {
        return {
            isRouterAlive: true,
            callData: null
        };
    },
    created() {
    },
    computed: {},
    mounted() {
        console.log('---------- mounted----------');
    },
    methods: {
        checkLogin() {
            // cart().then((res) => {
            //     if (res.success) {
            //         console.log('是否进入');
            //         this.$store.commit("changeLogin", 1);
            //         this.$store.commit("setPurchaselist", res.result);
            //     } else {
            //         this.$store.commit("changeLogin", 0);
            //         this.$store.commit("setPurchaselist", {});
            //     }
            // });
            getUser().then((res) => {
                let wsmemberId = this.$cookie.get("wsmemberId");
                if (res.success) {
                    this.$store.commit("setUserInfo", res);
                    if (wsmemberId == '' || wsmemberId == null) {
                        if (this.$store.state.login_status) {//已登录
                            this.$cookie.set("wsmemberId", this.$store.state.user_info.memberRoles[0].memberId);
                        }
                    }
                    if (res.audit == "1") {
                        this.$confirm(
                            "您好,您有" +
                            res.auditCount +
                            "条待审批请购单，请尽快完成审批",
                            "信息",
                            {
                                customClass: "confirm_message_box",
                                confirmButtonClass: "confirm_btn",
                                cancelButtonClass: "cancel_btn",
                                confirmButtonText: "进入审批",
                                cancelButtonText: "下次再说",
                            }
                        )
                            .then((_) => {
                                console.log("点击了确定");
                                this.$router.push("/approval");
                            })
                            .catch((_) => {
                                console.log("下次再说");
                            });
                    }
                } else {
                    console.log('getUser返回false')
                    this.$store.commit("setUserInfo", {});
                    if (wsmemberId == '' || wsmemberId == null) {
                        let memberId = uuidv4();
                        memberId = memberId.replace(/-/g, "");
                        wsmemberId = memberId;
                        this.$cookie.set("wsmemberId", wsmemberId.substr(0,24)+'customer');
                    }
                }
                // if(this.$globalSocket.socket){
                //     this.$globalSocket.closeWebsocket();
                // }
                this.$globalSocket.connectWebSocket((result) => {
                });
            });
        },
        // 刷新
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(() => {
                this.isRouterAlive = true;
            });
        },
    },
    watch: {
        $route: {
            handler(nv, ov) {
                //这个adminonline是后台管理端的在线客服路由
                if (nv.name != 'adminonline') {
                    this.checkLogin();
                }
            },
        },
        deep: true,
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue